import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Card from 'react-bootstrap/Card';
import styled from 'styled-components';
import { ButtonStyled } from 'components/UI/styled/button-styled';

export const CardHeaderStyled = styled(Card.Header)`
  background: transparent;
  border: none;
  border-radius: 8px !important;
  padding: 0.75rem 10px;
`;

export const RowStyled = styled.div`
  display: flex;
  position: relative;
  align-items: center;
`;

export const EditButton = styled(ButtonStyled)`
  position: absolute;
  right: 50px;
  top: 0;
`;

export const ArrowDown = styled(FontAwesomeIcon)`
  position: absolute;
  right: 0;
`;
